export const passwordCriteriaCheck = (check) => {
    const criteria = {};
    const specialChars = ['!', '"', '#', '%', '&', '\'', '(', ')', '*', ',', '-',
                          '.', '/', ':', ';', '?', '@', '[', '\\', ']', '_', '{',
                          '}', '¡', '§', '«', '¶', '·', '»', '¿', '$', '+', '<',
                          '=', '>', '^', '`', '|', '~', '¢', '£', '¤', '¥', '¦',
                          '¨', '©', '¬', '®', '¯', '°', '±', '´', '¸', '×', '÷'];

    criteria.length = check.length >= 8;
    criteria.lower = RegExp('[a-z]').test(check);
    criteria.upper = RegExp('[A-Z]').test(check);
    criteria.number = RegExp('[0-9]').test(check);
    criteria.symbol = RegExp(`[${specialChars.join('')}]`).test(check);
    criteria.strength = 0;

    if (criteria.lower || criteria.upper || criteria.number) {
        criteria.strength = 1;
    }
    if (criteria.lower && criteria.upper && criteria.number && criteria.length) {
        criteria.strength = 2;
        if (criteria.symbol) {
            criteria.strength = 3;
            if (check.length >= 12) {
                criteria.strength = 4;
            }
        }
    }

    return criteria;
};